import { CRM } from "@/components/atomic-crm/root/CRM";

const App = () => <CRM title="LINEAGRIS · CRM" />;

export default App;
